import constants from '../../_constants/bank-statements.constants';
import service from '../../../services/bank-statement.service';
import alertActionCreators from '../alert.actions';

const updateManyBankStatementEntries = (params, callback) => {
  return (dispatch) => {
    dispatch(request(params));

    service.updateMany(params).then(
      (response) => {
        dispatch(success(response.data));
        dispatch(alertActionCreators.success('Lançamentos atualizados com sucesso.'));

        if (callback) {
          callback();
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(params) {
    return {
      type: constants.BANK_STATEMENTS_UPDATE_MANY_ENTRIES_REQUEST,
      payload: { params },
    };
  }
  function success(entries) {
    return {
      type: constants.BANK_STATEMENTS_UPDATE_MANY_ENTRIES_SUCCESS,
      payload: { entries },
    };
  }
  function failure(error) {
    return {
      type: constants.BANK_STATEMENTS_UPDATE_MANY_ENTRIES_FAILURE,
      payload: { error },
    };
  }
};

export default updateManyBankStatementEntries;
